import { apiClient, handleRequest } from '@/shared/api';
import type {
  GetSccrsGamingHallsParams,
  GetSccrsGamingHallsResponseDto,
} from './types';
import { objectToQueryParamsStr } from '@/shared/utils';

export const getSccrsGamingHalls = async (
  params?: GetSccrsGamingHallsParams
) => {
  const queryString = objectToQueryParamsStr(
    (params as Record<string, string>) || {}
  );
  const request = () =>
    apiClient.get(
      `/operations/sccrs/gaminghalls${params?.halltype ? `?${new URLSearchParams(queryString)}` : ''}`
    );
  const response = await handleRequest<GetSccrsGamingHallsResponseDto>(request);
  return response.data;
};
